var map = {
	"./decidim/avatar-multiuser.png": 65996,
	"./decidim/brands/google.svg": 38211,
	"./decidim/cc-badge.png": 86366,
	"./decidim/decidim-logo.svg": 42350,
	"./decidim/default-avatar.svg": 26490,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 30862,
	"./decidim/icons.svg": 61709,
	"./decidim/pattern.png": 64202,
	"./decidim/placeholder-card-g.svg": 91239,
	"./decidim/placeholder-card-l.svg": 1532,
	"./decidim/placeholder.jpg": 32195,
	"./decidim/remixicon.symbol.svg": 34603,
	"./decidim/vendor/leaflet/layers-2x.png": 71470,
	"./decidim/vendor/leaflet/layers.png": 49013,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 96924,
	"./decidim/vendor/leaflet/marker-icon.png": 79755,
	"./decidim/vendor/leaflet/marker-shadow.png": 40656,
	"./decidim/vendor/social-share-button/douban.svg": 92858,
	"./decidim/vendor/social-share-button/email.svg": 29655,
	"./decidim/vendor/social-share-button/facebook.svg": 72809,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 24299,
	"./decidim/vendor/social-share-button/hacker_news.svg": 30235,
	"./decidim/vendor/social-share-button/linkedin.svg": 79527,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 18688,
	"./decidim/vendor/social-share-button/pinterest.svg": 7129,
	"./decidim/vendor/social-share-button/reddit.svg": 22697,
	"./decidim/vendor/social-share-button/telegram.svg": 18224,
	"./decidim/vendor/social-share-button/tumblr.svg": 84615,
	"./decidim/vendor/social-share-button/twitter.svg": 46630,
	"./decidim/vendor/social-share-button/vkontakte.svg": 42008,
	"./decidim/vendor/social-share-button/wechat.svg": 26691,
	"./decidim/vendor/social-share-button/whatsapp.svg": 70363,
	"./decidim/vendor/social-share-button/x.svg": 4924,
	"./decidim/vendor/social-share-button/xing.svg": 75785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85899;